
import { useIsMobile } from "@/hooks/use-mobile";
import { Briefcase, GraduationCap, School, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SituationCard from "./situation/SituationCard";
import SituationImage from "./situation/SituationImage";
import ActionButton from "./situation/ActionButton";
import { useImageFetcher } from "./situation/useImageFetcher";

const NewSectionTwo = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { getBackgroundImage } = useImageFetcher({ 
    section: "section-two" 
  });

  const fallbackImageUrl = 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80';
  const backgroundImage = getBackgroundImage(fallbackImageUrl);

  const scrollToNextSteps = () => {
    const section = document.getElementById('next-steps');
    if (section) {
      const offset = -80;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const handleNavigateToDetail = (path: string) => {
    console.log("Navigating to:", path);
    navigate(path);
  };

  return (
    <div id="new-section-two" className="relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50" />
      <div className="relative bg-gradient-to-r from-[#243949] to-[#517fa4] [&>*]:relative">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <h3 className="text-lg md:text-xl font-bold text-white mb-8 text-center uppercase">
            DEINE SITUATION
          </h3>
          
          {isMobile ? (
            <div className="flex flex-col md:flex-row md:items-center md:space-x-8">
              <SituationImage imageUrl={backgroundImage} isMobile={true} section="section-two" />
              <div className="w-full md:w-1/2 grid gap-3">
                <SituationCardsContent onNavigate={handleNavigateToDetail} />
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <SituationImage imageUrl={backgroundImage} isMobile={false} section="section-two" />
              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                <SituationCardsContent onNavigate={handleNavigateToDetail} />
              </div>
            </div>
          )}
          
          <div className="flex justify-center mt-8">
            <ActionButton 
              onClick={scrollToNextSteps}
              text="Interesse am Coaching mit mir?"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper component to avoid duplicating the cards between mobile and desktop layouts
const SituationCardsContent = ({ onNavigate }: { onNavigate: (path: string) => void }) => {
  return (
    <>
      <SituationCard 
        icon={<School className="w-6 h-6 text-white" />}
        text={<>Du machst <strong>Abi</strong> und weißt <strong>nicht</strong> <strong>welches</strong> <strong>Studium</strong>?</>}
        onClick={() => onNavigate("/abiturient")}
      />
      <SituationCard 
        icon={<GraduationCap className="w-6 h-6 text-white" />}
        text={<>Du <strong>studierst</strong> und merkst, das ist <strong>nicht</strong> <strong>das Richtige</strong>?</>}
        onClick={() => onNavigate("/student")}
      />
      <SituationCard 
        icon={<Briefcase className="w-6 h-6 text-white" />}
        text={<>Du <strong>arbeitest</strong>, aber bist <strong>nicht</strong> <strong>glücklich</strong> dabei?</>}
        onClick={() => onNavigate("/professional")}
      />
      <SituationCard 
        icon={<Sparkles className="w-6 h-6 text-white" />}
        text={<><strong>Mit mir</strong> findest du den <strong>Weg</strong>, der dich <strong>glücklich</strong> macht und auf dem deine <strong>Stärken erstrahlen</strong>.</>}
        isHighlighted={true}
        onClick={() => {}}
      />
    </>
  );
};

export default NewSectionTwo;
